var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M23 44L25 44 28 41 20 41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA8DA",
    d: "M26,42h-4c-2.2,0-4-1.8-4-4v-4h12v4C30,40.2,28.2,42,26,42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C6BC0",
    d: "M30 38l-11.6 1.6c.3.7.9 1.4 1.6 1.8l9.4-1.3C29.8 39.5 30 38.8 30 38zM18 35.7L18 37.7 30 36 30 34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M18,34c-3-1.9-9-8-9-15c0-8.3,6.7-15,15-15c8.3,0,15,6.7,15,15c0,7-6,13.1-9,15H18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF176",
    d: "M30.6,17.2l-3-2c-0.3-0.2-0.8-0.2-1.1,0L24,16.8l-2.4-1.6c-0.3-0.2-0.8-0.2-1.1,0l-3,2c-0.2,0.2-0.4,0.4-0.4,0.7c0,0.3,0,0.6,0.2,0.8l3.8,4.7V34h2V23c0-0.2-0.1-0.4-0.2-0.6l-3.3-4.1l1.5-1l2.4,1.6c0.3,0.2,0.8,0.2,1.1,0l2.4-1.6l1.5,1l-3.3,4.1C25.1,22.6,25,22.8,25,23v11h2V23.4l3.8-4.7c0.2-0.2,0.3-0.5,0.2-0.8C30.9,17.6,30.8,17.3,30.6,17.2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.da12e1da7fde774738acb499878a1901.svg";
export { ForwardRef as ReactComponent };